<template>
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 12a6 6 0 1 0-6-6 6 6 0 0 0 6 6m0-10a4 4 0 1 1-4 4 4 4 0 0 1 4-4m0 12a9 9 0 0 0-9 9 1 1 0 0 0 2 0 7 7 0 0 1 14 0 1 1 0 0 0 2 0 9 9 0 0 0-9-9"/></svg>
</template>
